import { FragmentStopReason } from '@/shared/api/transcriptor';

import { TranscriptorConsultation } from '../config';

/**
 * Every reason except the user's own Finish means the recording ended
 * without the doctor deciding so; the report must say so instead of
 * presenting a summary of half a consultation as complete. `null` (legacy
 * fragments) is treated as a normal stop.
 */
export const isInterruptedStopReason = (
  stopReason: FragmentStopReason | null,
): boolean => stopReason !== null && stopReason !== 'user';

export const hasInterruptedRecording = (
  consultation?: TranscriptorConsultation | null,
): boolean =>
  Boolean(
    consultation?.recordings.some((recording) =>
      isInterruptedStopReason(recording.stopReason),
    ),
  );

/**
 * Total recorded seconds across fragments — the single-encounter DTO has no
 * aggregate, so the notice sums what each fragment reports.
 */
export const getRecordingsDurationSec = (
  consultation?: TranscriptorConsultation | null,
): number =>
  Math.round(
    consultation?.recordings.reduce(
      (total, recording) => total + recording.durationSec,
      0,
    ) ?? 0,
  );
